"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var common_hooks_1 = require("@l2p/common-hooks");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var swiper_1 = require("swiper");
var react_2 = require("swiper/react");
var PaymentSystems_1 = __importDefault(require("./PaymentSystems"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
require("./styles.scss");
var swr_hooks_1 = require("@l2p/swr-hooks");
var MobilePaymentsSystem = function () {
    var slider = (0, react_1.useRef)(null);
    var t = (0, next_intl_1.useTranslations)('translation');
    var liveChatVisibility = (0, common_hooks_1.useLiveChatVisibility)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var config = (0, swr_hooks_1.useConfig)();
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.wrapper, " mobile-payments-info") },
        react_1.default.createElement(react_2.Swiper, { onBeforeInit: function (swiper) {
                slider.current = swiper;
            }, className: styles_module_scss_1.default.swiper, loop: true, modules: [swiper_1.Navigation], spaceBetween: 0, slidesPerView: 1, navigation: true, pagination: { clickable: true }, autoplay: false },
            react_1.default.createElement(react_2.SwiperSlide, { key: "slider1" },
                react_1.default.createElement(PaymentSystems_1.default, null)),
            react_1.default.createElement(react_2.SwiperSlide, { key: "slider2" },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.infoItem },
                    react_1.default.createElement(image_1.default, { src: "/img/icons/casino-outline.svg", width: 23, height: 23, alt: "icon games" }),
                    react_1.default.createElement("span", null, t('mainBannerInfoGames')))),
            react_1.default.createElement(react_2.SwiperSlide, { key: "slider3" },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.infoItem, onClick: function () {
                        if (!(config === null || config === void 0 ? void 0 : config.liveChatShouldDisabled))
                            liveChatVisibility();
                    } },
                    react_1.default.createElement(image_1.default, { src: "/img/icons/timer.svg", width: 23, height: 23, alt: "icon games" }),
                    react_1.default.createElement("span", null, t('mainBannerInfoSupport')))),
            react_1.default.createElement(react_2.SwiperSlide, { key: "slider4" },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.infoItem, onClick: openSignUp },
                    react_1.default.createElement(image_1.default, { src: "/img/icons/support-agent-rounded.svg", width: 23, height: 23, alt: "icon games" }),
                    react_1.default.createElement("span", null, t('mainBannerInfoPayment')))))));
};
exports.default = MobilePaymentsSystem;
